<template>
  <div class="d-flex align-items-center p-3 my-3 text-white rounded shadow-sm page-header-bg">
    <show-icon v-if="icon" :name="icon" size="lg" class="align-middle me-3"></show-icon>
    <div>
      <slot></slot>
    </div>
  </div>  
</template>

<script>
import { ref } from 'vue';

export default {
  name: "PageHeader",
  props: [
    'icon'
  ],
  setup(props) {
    const icon = ref(props.icon);
    return {
      icon
    }
  }
}
</script>